var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcShareCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#2E2E2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2506 20.4011L22.3001 26.3517C22.057 26.5947 21.692 26.6673 21.374 26.5358C21.0569 26.4043 20.8497 26.0943 20.8497 25.7508V23.2141C15.1876 23.407 12.9673 25.4846 12.9451 25.5068H12.9443C12.6758 25.7682 12.2669 25.8224 11.9386 25.6407C11.6103 25.4582 11.4397 25.0828 11.5194 24.7163C11.537 24.6358 13.3284 16.9719 20.8496 16.43V13.8497C20.8496 13.5062 21.0568 13.1962 21.374 13.0647C21.6919 12.9332 22.0569 13.0058 22.3 13.2488L28.2506 19.1994C28.4099 19.3588 28.5 19.5747 28.5 19.8002C28.5 20.0258 28.4099 20.2417 28.2506 20.4011L28.2506 20.4011Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShareCircle);
export default __webpack_public_path__ + "static/media/ic-share-circle.46eb9f45a3290115d9ea2bd14216be4d.svg";
export { ForwardRef as ReactComponent };